/* eslint-disable import/prefer-default-export */
import { ILine } from '../../share/types/ark1.0/types';

export const TOP_BAR_HEIGHT = 60;
export const DEFAULT_LOT_WIDTH = 0;
export const DEFAULT_LOT_HEIGHT = 0;

export const NOT_SELECTED = '';
export const EMPTY_LINE_LIST: ILine[] = [];
export const LOT_UNDO = 'LOT_UNDO';
export const LOT_REDO = 'LOT_REDO';
export const LOT_UNDO_SELECTOR = 'LOT_UNDO_SELECTOR';
export const LOT_REDO_SELECTOR = 'LOT_REDO_SELECTOR';
export const VERTICES = {
  VERTEX_RADIUS: 10,
  COLOR: {
    SELECTED: '#00A3FF',
    REGULAR: '#F1F5F9',
  },
  STROKE: {
    WIDTH: 1.5,
    COLOR: '#00A3FF',
  },
};

export const LOT_LINE = {
  STROKE: {
    WIDTH: 6,

  },
};

export const mapLotTypeToDefault: { [lotType: string]: {
  valueW: number,
  valueH: number } } = {
  CORNER_LOT: {
    valueW: 100,
    valueH: 100,
  },
  TWO_CORNER_LOT: {
    valueW: 200,
    valueH: 200,
  },
  INFILL_LOT: {
    valueW: 100,
    valueH: 100,
  },
  IRREGULAR: {
    valueW: 100,
    valueH: 100,
  },
  THROUGH_LOT: {
    valueW: 100,
    valueH: 100,
  },
  ENTIRE_BLOCK: {
    valueW: 100,
    valueH: 100,
  },
};
